document.addEventListener("DOMContentLoaded", () => {
    const headers = document.querySelectorAll(".case-study__header");

    headers.forEach((header) => {
        const icon = header.querySelector(".case-study__icon");
        const contentBody = header.nextElementSibling;

        icon.addEventListener("click", () => {
            const isOpen = contentBody.classList.contains("open");
            if (isOpen) {
                contentBody.classList.add("fade-out");
                icon.classList.remove("open");

                setTimeout(() => {
                    contentBody.classList.remove("fade-out");
                    contentBody.classList.remove("open");
                    contentBody.style.display = "none";
                }, 400);
            } else {
                contentBody.style.display = "flex";
                setTimeout(() => {
                    contentBody.classList.add("open");
                    icon.classList.add("open");
                }, 10);

    }
});

        // TODO on keyboard Enter event
        icon.addEventListener("keypress", (e) => {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                icon.click();
            }
        });
    });
});
